import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';

import { useStores } from '../../hooks/use-stores';

import Product from '../../components/OrderDetails/Product';
import OrderHeader from '../../components/OrderDetails/OrderHeader';
import NotificationModal from '../../components/NotificationModal';
import Delivery from '../../components/OrderDetails/Delivery';
import Loader from '../../components/Loader';

const OrderDetails = observer(() => {
    const { ProfileOrderStore: store } = useStores();
    const { getOrder, showModal, hideModal, modalMessage, loaderOrder, removeOrder } = store || {};
    const { id } = useParams();

    useEffect(() => {
        getOrder(id);
        return () => {
            removeOrder();
        };
    }, [getOrder, removeOrder, id]);

    if (loaderOrder) return <Loader />;

    return (
        <>
            <ul className="breadcrumbs">
                <li className="breadcrumbs__item">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 13L1 7L7 1" stroke="#CC0514" />
                    </svg>
                    <Link className="breadcrumbs__link" to="/orders/">
                        Все заказы
                    </Link>
                </li>
            </ul>
            <NotificationModal open={showModal} onClose={hideModal} message={modalMessage} />
            <div className="default-title-block mb-25">Информация</div>
            <OrderHeader />
            <Product />

            <div className="default-title-block mb-25">Доставка</div>

            <Delivery />
        </>
    );
});

export default OrderDetails;
